module.exports = __webpack_public_path__ + "static/img/2.a6fbd73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/5/2.png
// module id = lb+l
// module chunks = 0